import React, { Component } from 'react';
import { get } from 'lodash';
import { connect } from 'react-redux';
import config from '../../config/config';
import Modal from './Modal';
import Spinner from './Spinner';
import RetryLink from './RetryLink';

var downloadSvg = require('!svg-inline-loader!../../../public/img/download.svg');

class ExportModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            showAllScheduled: false,
            requestedAt: null
        };
        this.showModal = this.showModal.bind(this);
        this.exportAll = this.exportAll.bind(this);
    }
    
    showModal(show) {
        this.setState({
            showModal: show !== undefined ? show: !this.state.showModal,
            showAllScheduled: false
        })
    }
    
    exportAll(exportAllToCsv) {
        exportAllToCsv().then(exportData=>{
            const requestedAt = exportData.status == 'running' ? exportData.enqueued_at : null;
            this.setState({
                showAllScheduled: true,
                requestedAt
            })
        })
    }

    render() {
        const { exportToCsv, exportAllToCsv, loading = false, limit } = this.props;
        const adminReports = get(this.props, 'user.user.statement_reports', false);
        const limitValue = get(limit, 'value', 10);
        const { showAllScheduled } = this.state;
        const { fullCSVThreshold } = config;
        
        return <span>
            <Modal show={this.state.showModal} 
                title="Export Data" 
                showActionButtons={false}
                dialogClassName="confirm-modal-holder dialog-modal"
                handleClose={()=>this.showModal(false)}
            >   
                {!showAllScheduled && <React.Fragment>
                <p className="export-modal">
                    <span className="popup-confirm-text">These reports are for analytical purposes only and should not be used to pay artist royalties</span>
                </p>
                <p className="export-modal">
                    <a className="export-link" onClick={()=>exportToCsv(false)}>Export Current (up to {limitValue} rows)</a>
                    {!adminReports && <a className="export-link" onClick={()=>exportToCsv(true)}>Export Max (up to {fullCSVThreshold} rows)</a>}
                    {adminReports && <a className="export-link" onClick={()=>this.exportAll(exportAllToCsv)}>Export All Data</a>}
                    <Spinner enabled={loading} />
                </p>
                </React.Fragment>}
                {showAllScheduled && <p className="export-modal">
                    <span className="popup-confirm-text">Your export is scheduled. Check your inbox for an email from noreply@secretlydistribution.com</span>
                    <RetryLink requestedAt={this.state.requestedAt} retry={()=>this.exportAll(exportAllToCsv)} />
                </p>}
            </Modal>
            <a key="download" title="Export" onClick={()=>this.showModal(true)} className="chart-icon download-link" dangerouslySetInnerHTML={{__html: downloadSvg}} />
        </span>
    }
}
function mapStateToProps(state) {
    return {
        user: state.user,
        filter: state.filter
    } 
}

export default connect(mapStateToProps)(ExportModal)